import type { CellProps } from "react-table";

import type { IApplication } from "../../../hooks/reactQueryHooks/useApplications";
import type { IData } from "../../../types";
import { ConversationIndicator } from "../../ConversationIndicator/ConversationIndicator";
import { DotDivider } from "../../DotDivider/DotDivider";

interface RequestsProps extends CellProps<IData> {
  applications: Array<IApplication>;
}

export const RequestColumn = ({ row, applications }: RequestsProps) => {
  const applicationId = row?.original?.applicationId;
  const applicationName = applications?.find(
    app => app.id === applicationId,
  )?.name;
  const messages = row.original.request.body?.messages;
  const content = messages[messages.length - 1]?.content || "";

  return (
    <div className="custom-column-name">
      <div className="fs-9 fw-500 app-name">
        {applicationName}
        {messages.length > 2 && (
          <>
            <DotDivider />
            <ConversationIndicator value={messages.length - 1} />
          </>
        )}
      </div>
      <div className="two-lines-text" title={content}>
        {content || <i>No prompt</i>}
      </div>
    </div>
  );
};
